
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CFormInput, CFormLabel, CFormTextarea, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react';
import { useEffect, useState } from 'react';
import Graytextarea from '../../components/Graytextarea';
import SaveExtra from '../../../src/services/general/saveExtraData.api';
import PatientOrdersCRUD from '../../../src/services/general/patientOrders.api';
import { Circle, Plus } from 'lucide-react';
import AddOrders from './AddOrders';
import { backgroundColor } from '@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/items';
import { useIndexedDB } from '../../context/IndexedContext';
const ProviderTreatmentPlans = ({ noteStructureRef, saveTreatsShell, isAllotedToProvider = false,patientDBData, setPatientDBData, addedChangesToAssessment, setAddedChangesToAssessment, patientID, showDataIfNoteIsFollowUp, allTreamentStatements, setAllTreatmentStatements, contentEditable = false, isTextInput, showTreatmentAsAccordion, diagnosisName, patientTreatments, medicationList, masterMedications, allLabs, noteID , noteCallType }) => {
  console.log(noteStructureRef, noteCallType ,'note call type innn TP ')
  const [allData, setAllData] = useState([])
  const [planFormat, setPlanFormat] = useState("")
  const [lab, setLab] = useState("")
  const [planSuggestion, setPlanSuggestion] = useState("")
  const [templateStatement, setTemplateStatement] = useState("")
  const [misc, setMisc] = useState("")
  const [testMisc, setTestMisc] = useState("")
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [orders, setOrders] = useState([]);
  const [freeType, setFreeType] = useState('')
  const [freeModelVisible, setIsFreeModalVisible] = useState(false);
  const [tempText, setTempText] = useState('')
  const [allOrdersOffline, setAllOrdersOffline] = useState([])
  const [ allMedication , setAllMedication] = useState(null)
  
  const {
    getOfflineData,
    saveOfflineData,
    getProviderDetails,
    getOpenChartOfflineData,
    saveOpenChartOfflineData
  } = useIndexedDB()
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const getProvidersMaster = async () => {
    // setIsPageLoading(true)
    try {
      // Fetch provider data
      const getProviderDetailsData = await getProviderDetails()

      setLoggedUserProvider(getProviderDetailsData || {})
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [])
  const fetchOfflineData = async () => {
    const data = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
    if (data) {
      console.log(data?.[loggedUserProvider?.ID]?.[patientID], 'data?.[loggedUserProvider?.ID]?.[patientID]')
      console.log(
        data?.[loggedUserProvider?.ID]?.[patientID]?.ordersData
          // ?.filter((item) => item?.medication?.noteID === (parseInt(noteID) === 0 ? 0 : parseInt(noteID) - 1)) 
          .filter(item => item.medication?.diagnosis?.trim() === diagnosisName?.trim())
        || [],
      );
      setOrders(
        data?.[loggedUserProvider?.ID]?.[patientID]?.ordersData
          // ?.filter((item) => item?.medication?.noteID === (parseInt(noteID) === 0 ? 0 : parseInt(noteID) - 1)) 
          .filter(item => item.medication?.diagnosis === diagnosisName)
        || []
      );
    }
  }

  useEffect(() => {
    fetchOfflineData()
  }, [loggedUserProvider])

  console.log(orders, 'allOrdersOffline in plan',diagnosisName)
  // const fetchOrders = async () => {
  //     try {

  //         let data = await PatientOrdersCRUD('Get', "", patientID);

  //         data = JSON.parse(data?.d).Data || [];

  //         const parsedOrders = data?.map(order => ({
  //             // ...order,
  //             date: order.date,
  //             medication: JSON.parse(order.medication)
  //         }))
  //             .filter(item => item.medication?.diagnosis === diagnosisName)

  //         console.log(data, 'data orders', diagnosisName)

  //         setOrders(parsedOrders)

  //     } catch (error) {
  //         console.error('Failed to fetch or parse orders:', error);
  //     }
  // };

  // useEffect(() => {
  //   fetchOrders()
  // }, [])


  useEffect(() => {
    const matched = allTreamentStatements?.length > 0 && allTreamentStatements?.find(
      (item) => item.Data?.diagnosis?.label === diagnosisName
    );

    if (matched) {
      console.log(matched, 'matched,')
      const suggestionNames = matched.Data.accordions.flatMap(
        (accordion) => accordion?.suggestions?.suggestionName || []
      ).map((s) => s.name);
      const joinedStatements = suggestionNames?.join('\n')
      console.log(joinedStatements, diagnosisName, 'joinedStatements')
      setTemplateStatement(joinedStatements);

      if (joinedStatements) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          plans: {
            ...noteStructureRef.current.plans,
            [diagnosisName]: {
              ...noteStructureRef?.current?.plans?.[diagnosisName],
              templateStatement: joinedStatements,
            }
          },
        }
      }
    }
  }, [allTreamentStatements])


  useEffect(() => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans?.[diagnosisName],
          templateStatement: noteStructureRef.current.plans?.[diagnosisName]?.templateStatement || "",
          medsDetails: noteStructureRef.current.plans?.[diagnosisName]?.medsDetails || [],
          labRemark: noteStructureRef.current.plans?.[diagnosisName]?.labRemark || "",
          freeType: noteStructureRef.current.plans?.[diagnosisName]?.freeType || "",
          orders: noteStructureRef.current.plans?.[diagnosisName]?.orders || [],
          planSuggestion: noteStructureRef.current.plans?.[diagnosisName]?.planSuggestion || "",
        },
      },
    };
  }, [templateStatement, lab, misc, planSuggestion, orders, freeType]);


  const handleMedicationAdd = () => {

    let lastLabsRemarks = [];
    let newAssessment = '';

    if (allLabs?.length > 0) {
      const lastLab = allLabs[allLabs.length - 1];

      const lastLabArrOfLabs = lastLab?.data || [];

      let allMatchingLab = lastLabArrOfLabs.filter(item => {
        const diagnosisLab = item.diagnosis.split(",").filter(item => item !== '');
        return diagnosisLab.some(diagn => diagn.includes(diagnosisName));
      });

      lastLabsRemarks = allMatchingLab.map(item => item.planRemark).filter(item => item !== '');
    }

    if (lastLabsRemarks.length > 0) {

      if (newAssessment !== '') {
        newAssessment += '\n\n'; // Add a separator between previous and new content
      }
      newAssessment += lastLabsRemarks.join('\n');
      setLab(newAssessment)
      // setMisc(newAssessment)
      noteStructureRef.current = {
        ...noteStructureRef.current,
        plans: {
          ...noteStructureRef.current.plans,
          [diagnosisName]: {
            ...noteStructureRef?.current?.plans?.[diagnosisName],
            labRemark: newAssessment,
          }
        },
      };
    }

    if (medicationList && medicationList.length > 0 && masterMedications && masterMedications.length > 0) {

      const lastMedicationAdded = medicationList[0] || [];
      // const lastMedicationAdded = medicationList[0];

      console.log("lastMedication", lastMedicationAdded);


      if (!lastMedicationAdded) return;
      const { data } = lastMedicationAdded;

      let dataForParticularMeds = [];

      for (const medsInBundle of data) {

        // if (medsInBundle?.Diagnosis?.length > 0) {
        //     const findMasterHavingMedsName = medsInBundle?.Diagnosis.map((item) => item.label).includes(diagnosisName)
        //     console.log("findMasterMedication", findMasterHavingMedsName, medsInBundle);
        //     if (findMasterHavingMedsName) {
        //         dataForParticularMeds.push({
        //             editedMed: `${medsInBundle?.name} ${medsInBundle?.dosage} ${medsInBundle?.route} ${medsInBundle?.frequency}`,
        //         });
        //     }
        // }

        const findMasterHavingMedsName = masterMedications.find(item => item.Data.name === medsInBundle.name);
        if (findMasterHavingMedsName) {
          if (findMasterHavingMedsName.Data?.diagnoses.includes(diagnosisName)) {
            dataForParticularMeds.push({
              // ...findMasterHavingMedsName?.Data, medDetail: medsInBundle,
              id: findMasterHavingMedsName.Data?.id,
              name: findMasterHavingMedsName.Data?.name,
              sideEffect: findMasterHavingMedsName.Data?.sideEffect,
              mechanismOfAction: findMasterHavingMedsName.Data?.mechanismOfAction,
              alerts: findMasterHavingMedsName.Data?.alerts,
              therapeuticLevels: findMasterHavingMedsName.Data?.therapeuticLevels,
              standingTemplateName: findMasterHavingMedsName.Data?.standingTemplateName,
              extraStandings: findMasterHavingMedsName.Data?.standingTemplateName,
              frequency: medsInBundle?.frequency,
              dosage: medsInBundle?.dosage,
              // dosage: findMasterHavingMedsName.Data?.dosage,
              route: findMasterHavingMedsName.Data?.method,
              editedMed: `${findMasterHavingMedsName.Data?.name} ${medsInBundle?.dosage} ${findMasterHavingMedsName.Data?.method} ${medsInBundle?.frequency}`,
            });
          }
        }
      }

      const addCustomAsWell = data.filter((item) => item.Diagnosis && item.Diagnosis.some(dia => dia.label === diagnosisName) && !masterMedications.find(med => med.Data.name === item.name))?.map(item => ({
        id: item?.id,
        name: item?.name,
        sideEffect: '',
        mechanismOfAction: '',
        alerts: '',
        therapeuticLevels: {},
        standingTemplateName: '',
        extraStandings: '',
        frequency: item?.frequency,
        dosage: item?.dosage,
        route: item?.route,
        editedMed: `${item?.name} ${item?.dosage || ''} ${item?.route} ${item?.frequency}`,
      }))

      const formattedMedicationDetails = dataForParticularMeds.map(item => {
        return `${item?.name} - ${item?.dosage} - ${item?.medDetail?.frequency} \n${item?.standingTemplateName}`;
      }).join('\n\n');

      const formattedMedicationDetailsInFormattedRed = dataForParticularMeds.map(item => {
        // return `${item?.name} - <span>${item?.dosage}</span> - <span class="med-frequency" >${item?.frequency}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span></span>`;
        // return ` <span>${item?.editedMed}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.sideEffect}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.mechanismOfAction}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.alerts}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.therapeuticLevels?.min} - ${item?.therapeuticLevels?.max}</span>`;
        return ` <span style="color: #000000d9;">${item?.editedMed}</span> <br/> `;

      }).join('<br/><br/>')

      setAllData([...dataForParticularMeds,...addCustomAsWell])

      setPlanFormat(formattedMedicationDetailsInFormattedRed)
      // const combinedPlans = `${standingMedicationTemplate}${formattedMedicationDetails ? `\n\n${formattedMedicationDetails}` : ""}`;

      // setPlans(combinedPlans);
      noteStructureRef.current = {
        ...noteStructureRef.current,
        plans: {
          ...noteStructureRef.current.plans,
          [diagnosisName]: {
            ...noteStructureRef.current.diagnosisName,
            ...noteStructureRef?.current?.plans?.[diagnosisName],
            medsDetails: dataForParticularMeds,

          }
        },
      };

      // noteStructureRef.current = {
      //     ...noteStructureRef.current,
      //     medicationDetails: {
      //         ...noteStructureRef.current.medicationDetails,
      //         [diagnosisName]: dataForParticularMeds.length > 0 ? dataForParticularMeds : []
      //     }
      // };


    }
  }

  useEffect(() => {
    let lastLabsRemarks = [];
    let newAssessment = '';

    if (patientTreatments && patientTreatments.length > 0) {
      let treatmentDetails = patientTreatments[noteID || 0];

      console.log(treatmentDetails, 'treatmentDetails')

      if (!treatmentDetails) {
        treatmentDetails = patientTreatments[0];
      }

      const { data } = treatmentDetails;

      let miscing = data?.plans?.[diagnosisName]?.freeType || '';
      let freeType = data?.plans?.[diagnosisName]?.freeType || '';
      // let planSuggestion = noteStructureRef.current?.plans?.[diagnosisName].planSuggestion ? noteStructureRef.current?.plans[diagnosisName].planSuggestion : data?.plans?.[diagnosisName]?.planSuggestion
      let planSuggestion = noteStructureRef.current?.plans?.[diagnosisName]?.planSuggestion
        ?? data?.plans?.[diagnosisName]?.planSuggestion;

      // let treatmentStatement = data?.plans?.[diagnosisName]?.treatmentStatement || '';
      setPlanSuggestion(planSuggestion)



      const bimsScoreData = noteStructureRef?.current?.BIMSScore?.[diagnosisName];
      if (bimsScoreData && bimsScoreData.score) {
        const { date, score } = bimsScoreData;
        const formattedDate = new Date(date).toLocaleDateString('en-US'); // "4/23/2025"
        miscing += `\nBims Score: ${score} Date: ${formattedDate}`;
      }

      const morseScoreData = noteStructureRef?.current?.MorseScore?.[diagnosisName];
      if (morseScoreData?.score) {
        const morseScores = morseScoreData.score;
        const totalScore = Array.isArray(morseScores)
          ? morseScores[morseScores.length - 1]
          : morseScores;
        const formattedDate = new Date(morseScoreData.date).toLocaleDateString('en-US');
        miscing += `\nMorse Score: ${totalScore} Date: ${formattedDate}`;
      }
      console.log('misc data', miscing, freeType)
      // setMisc(miscing);
      if(freeType){
         setFreeType(freeType)
      }
      

      // noteStructureRef.current = data   /// if something is not work plan then uncomment it, may be work 
      let miscData = data && data.plans && data?.plans[diagnosisName]?.labRemark + data?.plans[diagnosisName]?.misc;
      // console.log("misc data==========>", data?.plans[diagnosisName]?.labRemark, data?.plans[diagnosisName]?.misc)
      setLab(data?.plans && data?.plans[diagnosisName] && (data?.plans[diagnosisName]?.labRemark))
      // setMisc(data?.plans && data?.plans[diagnosisName] && data?.plans[diagnosisName]?.misc)
      setAllData(data?.plans && data?.plans[diagnosisName] && data?.plans[diagnosisName]?.medsDetails)
      setAllMedication(data?.plans && data?.plans[diagnosisName] && data?.plans[diagnosisName]?.medsDetails)
      const formattedMedicationDetailsInFormattedRed = allData && allData.length > 0 && allData?.map(item => {
        // return `${item?.name} - <span>${item?.dosage}</span> - <span class="med-frequency" >${item?.frequency}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span></span>`;
        // return ` <span style="color: #000000d9;">${item?.editedMed}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.extraStandings}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.sideEffect}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.mechanismOfAction}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.alerts}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.therapeuticLevels?.min} - ${item?.therapeuticLevels?.max}</span>`;
        return ` <span style="color: #000000d9;">${item?.editedMed}</span> <br/> `;

      }).join('<br/><br/>')

      setPlanFormat(formattedMedicationDetailsInFormattedRed)
      

      handleMedicationAdd();
    }
    else {
      handleMedicationAdd();
    }

  }, [medicationList, masterMedications, diagnosisName, allLabs, patientTreatments, noteStructureRef, addedChangesToAssessment]);




  useEffect(() => {
    if (!diagnosisName) return;
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef?.current?.plans?.[diagnosisName] || {},
          medsDetails: allData
        }
      },
    };
  }, [allData])

  const handleTemplateStatementCchnage = (e) => {
    setTemplateStatement(e.target.value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef?.current?.plans?.[diagnosisName],
          templateStatement: e.target.value
        },
      },
    };
  }

  const handleMedicationChange = (e, index) => {
    const { value } = e.target;
    const updatedMeds = [...allData];
    updatedMeds[index].editedMed = value;
    setAllData(updatedMeds);
  }

  const handleStandingsChange = (e, index) => {
    const { value } = e.target;
    const updatedMeds = [...allData];
    updatedMeds[index].extraStandings = value;
    setAllData(updatedMeds);
  }

  const handleMiscChange = (e) => {
    const { value } = e.target;
    setFreeType(value)

    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef?.current?.plans?.[diagnosisName],
          freeType: value,
          // labRemark: lab,
        },
      },
    };
  };

    const handleAddFreeTypeOfflinePlans = async (tempText) => {
    let dataOffline = noteCallType === 'OpenChart' ? await getOpenChartOfflineData()  : await getOfflineData()
    if (dataOffline) {
      console.log('offlineData before adding freetupe in plans:', dataOffline);
      dataOffline = {
        ...dataOffline,
        [loggedUserProvider?.ID]: {
          ...dataOffline[loggedUserProvider?.ID],
          [patientID]: {
            ...dataOffline[loggedUserProvider?.ID][patientID],
            currentNote: {
              ...dataOffline[loggedUserProvider?.ID][patientID].currentNote,
              data: {
                ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data,
                plans: {
                  ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.plans,
                  [diagnosisName]: {
                    ...dataOffline[loggedUserProvider?.ID][patientID].currentNote.data.plans[diagnosisName],
                    freeType: tempText || '',
                  }
                }
              }
            },
            saveDraft : true
          }
        }
      }
    }
    console.log('offlineData after adding freetupe in plans:', dataOffline);
        noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(dataOffline)  : await saveOfflineData(dataOffline)

  }

  const handleSave = () => {
    console.log('freee type data', tempText)
    setFreeType(tempText)
    // Update the noteStructureRef only when saving
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans?.[diagnosisName],
          freeType: tempText,
          // labRemark: lab,
        },
      },
    }
    handleAddFreeTypeOfflinePlans(tempText)

    //  saveTreatsShell(false)
    setIsFreeModalVisible(false)
  }
  console.log(noteStructureRef.current, 'noteStructuree')

  // useEffect(() => {
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         plans: {
  //             ...noteStructureRef.current.plans,
  //             [diagnosisName]: {
  //                 ...noteStructureRef?.current?.plans?.[diagnosisName],
  //                 misc: misc,
  //                 // labRemark: lab,
  //             }
  //         },
  //     };
  // }, [misc])

  console.log('freeTypeinplan,', 1)

  useEffect(() => {
    const freeType = noteStructureRef.current?.plans?.[diagnosisName]?.freeType
    console.log(freeType, diagnosisName, 'freeTypeinplan')
      setFreeType(freeType)
  }, [noteStructureRef.current?.plans])

  return (
    <>
      <CAccordion className=" " flush>
        <CAccordionItem>
          <CAccordionHeader>
            <div className="d-flex gap-2 align-items-center">
              <h7>Plan</h7>
              {/* {showTreatmentAsAccordion && <h7 style={{ fontSize: "14px" }}><b>Plan</b></h7>} */}
              {isAllotedToProvider && (
                <CFormLabel
                  className="d-flex flex-column align-items-center mt-2 justify-content-center shadow "
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    setOrderModalVisible((p) => !p)
                  }}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: '#4363F2',
                    cursor: 'pointer',
                  }}
                >
                  <Circle className="text-white" strokeWidth={2} size={15} />
                </CFormLabel>
              )}
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            {!isTextInput ? (
              <div className="d-flex flex-column gap-3">
                <div className="d-flex flex-column gap-4 justify-content-center " style={{ position: '' }}>
                  {/* <div style={{
                                position: 'absolute',
                                top: '10px',
                                left: '13px',
                                pointerEvents: 'none',
                                fontSize: '1rem',

                            }}
                            >
                                {lab}
                            </div> */}

                  {/* Free Type */}
                  {/* <div style={{}}>
                      <CFormLabel>Free Type</CFormLabel>
                      <Graytextarea
                        onChange={handleMiscChange}
                        // className="w-100"
                        height={200}
                        style={{
                          minHeight: '180px',

                          fontSize: '1rem',
                          backgroundColor: '#282828',
                          border: '1px solid #989898',
                        }}
                        value={freeType}
                      />
                    </div> */}
                  <div>
                    <label className="text-white fw-semibold" style={{ fontSize: '14px' }}>
                      Free Type
                    </label>
                    <div
                      style={{
                        minHeight: '50px',
                        color: freeType ? 'white' : '#989898',
                        backgroundColor: '#282828',
                        border: '1px solid #989898',
                        marginTop: '10px',
                        padding: '10px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        whiteSpace: 'pre-line',
                        borderRadius: '10px',
                      }}
                      onClick={() => {
                        setTempText(freeType)
                        setIsFreeModalVisible(true)
                      }}
                    >
                      {freeType || (
                        <span
                          style={{
                            fontSize: '14px',
                            color: '#989898',
                          }}
                        >
                          Enter Free Type
                        </span>
                      )}
                    </div>
                    {/* <Graytextarea style={{ color: '#989898', background: '#252525', border: '1px solid gray' }} value={freeType} onChange={handleChanges} rows={5} /> */}
                  </div>

                  {/* Plan Suggestions */}
                  <div>
                    <CFormLabel>Plan Suggestions</CFormLabel>

                    <div
                      style={{
                        minHeight: '50px',
                        fontSize: '1rem',
                        backgroundColor: '#282828',
                        border: '1px solid #989898',
                        color: 'white',
                        padding: '10px',
                        borderRadius: '4px',
                        whiteSpace: 'pre-line',
                        borderRadius: '10px',
                      }}
                    >
                      {planSuggestion || (
                        <span
                          style={{
                            fontSize: '14px',
                            color: '#989898',
                          }}
                        >
                          No Plan Suggestions
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Labs */}
                  {/* <div>
                      <CFormLabel>Labs</CFormLabel>
                      <Graytextarea
                        style={{
                          minHeight: '50px',

                          fontSize: '1rem',
                          backgroundColor: '#282828',
                          border: '1px solid #989898',
                          color:'white'
                        }}
                        disabled
                        value={lab}
                      />
                    </div> */}
                  <div>
                    <label className="form-label text-white">Labs</label>
                    <div
                      style={{
                        minHeight: '50px',
                        fontSize: '1rem',
                        backgroundColor: '#282828',
                        border: '1px solid #989898',
                        color: 'white',
                        padding: '10px',
                        borderRadius: '4px',
                        whiteSpace: 'pre-line',
                        borderRadius: '10px',
                      }}
                    >
                      {lab || (
                        <span
                          style={{
                            fontSize: '14px',
                            color: '#989898',
                          }}
                        >
                          No Labs
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Orders */}
                  <div>
                    <div className="d-flex gap-2 align-items-center">
                      <CFormLabel>New Orders</CFormLabel>
                    </div>
                    <div>
                      {orders?.length > 0 ? (
                        orders
                          .filter((item) => item?.medication?.noteID === noteID)
                          .map((item, idx) => {
                            const currentOrder = item?.medication

                            return (
                              <div
                                key={idx}
                                className="mb-2"
                                style={{
                                  minHeight: '50px',
                                  padding: '10px',
                                  fontSize: '1rem',
                                  backgroundColor: '#282828',
                                  border: '1px solid #989898',
                                  borderRadius: '10px',
                                }}
                              >
                                {/* Imaging */}
                                {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Imaging:</strong>{' '}
                                    {currentOrder.imaging.imagingTypes
                                      .map((img) => img?.type)
                                      .filter(Boolean)
                                      .join(', ')}
                                  </p>
                                )}

                                {/* Labs */}
                                {currentOrder?.lab?.labs?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Labs:</strong>{' '}
                                    {currentOrder.lab.labs
                                      .map((labItem) => {
                                        const lab = labItem?.lab || ''
                                        const reason = labItem?.reason ? ` - Reason for ${lab}: ${labItem.reason}` : ''
                                        return `${lab}${reason}`
                                      })
                                      .join(', ')}
                                  </p>
                                )}

                                {/* Medications */}
                                {currentOrder?.medication?.medication?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Medications:</strong>{' '}
                                    {currentOrder.medication.medication
                                      .map((med) => {
                                        const details = [med?.name, med?.dosage, med?.route, med?.frequency].filter(Boolean).join(' ')
                                        return `${details}${med?.reason ? ` - ${med.reason}` : ''}`
                                      })
                                      .join(', ')}
                                  </p>
                                )}

                                {/* Miscellaneous */}
                                {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Miscellaneous:</strong> {currentOrder.miscellaneous.miscellaneous.join(', ')}
                                  </p>
                                )}
                              </div>
                            )
                          })
                      ) : (
                        <div
                          style={{
                            minHeight: '50px',
                            fontSize: '14px',
                            backgroundColor: '#282828',
                            border: '1px solid #989898',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start',
                            color: '#989898',
                            padding: '0 10px',
                          }}
                        >
                          No New Orders
                        </div>
                      )}
                    </div>
                  </div>

                  <div>
                    <CFormLabel>Current Medications</CFormLabel>
                    {allData && allData.length > 0 ? (
                      allData?.map((item, idx) => {
                        return (
                          <div
                            key={idx}
                            className="card mb-2 p-3 "
                            style={{
                              minHeight: '50px',
                              background: '#282828',
                              border: '1px solid #989898',
                              borderRadius: '10px',
                              color: 'white',
                            }}
                          >
                            {/* <CFormInput
                                onChange={(e) => {
                                  handleMedicationChange(e, idx)
                                }}
                                className="form-control my-2"
                                placeholder="Enter medication"
                                value={item.editedMed}
                                style={{
                                  background:''
                                }}
                              /> */}

                            <div>{item?.editedMed || ''}</div>
                            {/* <CFormInput
                                        onChange={(e) => { handleStandingsChange(e, idx) }}
                                        className="form-control my-2"
                                        placeholder="Enter standings"
                                        value={item.extraStandings}
                                    /> */}
                            <div className="mt-3">
                                <p className="text-warning mb-1">
                                  <strong style={{ color: '#FFDF00' }}>Side-effect:</strong>
                                  <span style={{ color: '#FFDF00' }}> {item?.sideEffect}</span>
                                </p>
                                <p className="text-warning mb-1">
                                  <strong style={{ color: '#FFDF00' }}>MOA:</strong>
                                  <span style={{ color: '#FFDF00' }}> {item?.mechanismOfAction}</span>
                                </p>

                                {item?.therapeuticLevels?.min && (
                                  <p className="text-warning mb-1">
                                    <strong style={{ color: '#FFDF00' }}>Min-Max:</strong>
                                    <span style={{ color: '#FFDF00' }}>{`${item?.therapeuticLevels?.min} - ${item.therapeuticLevels?.max}`}</span>
                                  </p>
                                )}
                                <p className="text-warning mb-1">
                                  <strong style={{ color: '#FFDF00' }}>Alert:</strong>
                                  <span style={{ color: '#FFDF00' }}> {item?.alerts}</span>
                                </p>
                              </div>
                          </div>
                        )
                      })
                    ) : (
                      <div
                        style={{
                          minHeight: '50px',
                          fontSize: '14px',
                          backgroundColor: '#282828',
                          border: '1px solid #989898',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'start',
                          color: '#989898',
                          padding: '0 10px',
                        }}
                      >
                        No Current Medication
                      </div>
                    )}
                  </div>

                  {/* Template Statements */}
                  <div>
                    <label className="text-white fw-semibold">Template Statements</label>
                    <div
                      style={{
                        minHeight: '50px',
                        fontSize: '1rem',
                        backgroundColor: '#282828',
                        border: '1px solid #989898',
                        color: 'white',
                        padding: '8px',
                        borderRadius: '10px',
                        whiteSpace: 'pre-line',
                      }}
                    >
                      {templateStatement || (
                        <span
                          style={{
                            fontSize: '14px',
                            color: '#989898',
                          }}
                        >
                          No Current Template
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {allData && allData.length > 0 && (
                  <div>
                    <div contentEditable={contentEditable} className="text-warning" dangerouslySetInnerHTML={{ __html: planFormat }} />
                    <div contentEditable={contentEditable} style={{ color: '#000000d9' }} dangerouslySetInnerHTML={{ __html: lab }} />
                    <div contentEditable={contentEditable} style={{ color: '#000000d9' }} dangerouslySetInnerHTML={{ __html: misc }} />
                  </div>
                )}
              </>
            )}
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>

      <CModal size="xl" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <AddOrders 
          patientDBData={patientDBData}
          setPatientDBData={setPatientDBData}
          noteStructureRef={noteStructureRef} patientID={patientID} noteID={noteID} diagnosisName={diagnosisName} toggleModal={() => setOrderModalVisible((p) => !p)} 
        // fetchOrdersAgain={fetchOrders}
        fetchOrdersAgain={fetchOfflineData}
        noteCallType={noteCallType}
        allData={allData}
        allMedication={allMedication}
         />
      </CModal>

      <CModal visible={freeModelVisible} onClose={() => setIsFreeModalVisible(false)} size="lg" alignment="center">
        <CModalHeader
          style={{
            backgroundColor: '#282828',
            borderBottom: '1px solid gray',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '10px 10px 0 0',
          }}
          closeButton
        >
          <CModalTitle
            style={{
              color: 'white',
              textAlign: 'center',
              width: '100%',
            }}
          >
            Free Type
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            backgroundColor: '#282828',
            color: 'white',
          }}
        >
          <Graytextarea style={{ color: 'white', background: '#252525', border: '1px solid gray', height: '200px' }} value={tempText} onChange={(e) => setTempText(e.target.value)} rows={5} />
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828',
            borderTop: '1px solid gray',
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            borderRadius: '0 0 10px 10px',
          }}
        >
          <CButton
            style={{
              backgroundColor: '#4363F2',
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            color="primary"
            onClick={() => handleSave()}
          >
            Save
          </CButton>
          <CButton
            style={{
              backgroundColor: '#333',
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            color="secondary"
            onClick={() => setIsFreeModalVisible(false)}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
};

export default ProviderTreatmentPlans;
